module.exports = __webpack_public_path__ + "static/media/file-PDF.6b3d4233.svg";